import React, { Component } from 'react';
import { Switch, Route ,Link} from 'react-router-dom';

import { connect } from 'react-redux'

import Wrapper from '../../components/wrapper/Wrapper';
import CheerBoxLogo from '../../assets/img/cheerbox-logo.svg';
import { getUser,createUser } from '../../actions/userActions'
import {Elements} from 'react-stripe-elements';
import InjectedCheckoutForm from './CheckoutForm';
import Typography from '@material-ui/core/Typography';
import './Payment.css'
import { getPricing,setPricing  } from '../../actions/pricingActions'

class Pricing extends Component {

    componentDidMount(){
        document.title="Cheerbox | Payment Page "

        this.props.getUser()

    }

    handleChange = e=>{
        this.props.setPricing(this.props.pricing[e.target.value])
    }


  render() {

    if(this.props.pricing.length === 0){

        this.props.getPricing()
    }
    

    const priceOptions = this.props.pricing.map((amount,index)=>{
        return(
            <option value={index}>{amount.package_amount}</option>

        )
    })

    return (
      <Wrapper>
        <div className="logo-section">
			<div className="container">
				<div className="row">
					<div className="col-md-4 head-group">
						<div className="mental-happy-logo">
							<img src={CheerBoxLogo} alt="Mental happy logo" width='120'/>
						</div>
					</div>
				</div>
			</div>
		</div>
			<div className="header">
				<div className="container">
					<div className="row">
						<div className="col-md-4"></div>
						<div className="col-md-4 ">
                    <div className="page-title">
                            <span>Let's finish setting up your account!</span>

                    </div>
						</div>
					</div>
				</div>
			</div>
			<div className="form-box">
				<div className="container">
					<div className="row">
                    <div className="col-md-12  animated fadeIn">

                    <div className="col-md-4 pull-left">
                    <div className="page-title">
                            <span>Payment Information</span>
                            

                    </div>                    
                    <Typography variant="caption">  
                        Orders over $2,000 can be invoiced. If you would like to be invoiced please contact us at <a href="https://cheerbox.com/contact" target="_blank">support@cheerbox.com</a>
                    </Typography><br/>

                        <Elements>
                            <InjectedCheckoutForm />
                        </Elements>
                    </div>

                    
                    <div className="col-md-7 pull-right">
                    <table class="table">
                    <thead>
                        <tr>
                        <th scope="col">Order</th>
                        <th scope="col">Total Cheerboxes</th>
                        <th scope="col">Total Unit Cost</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                        <td>Cheerboxes</td>
                        <td>
                        <span style={{padding:10}}>Quantity: {this.props.price.package_amount}</span>

                        <select style={{width:200,height:34}} defaultValue={this.props.country} class="custom-select custom-select-lg mb-3 required"   onChange={this.handleChange} >
                        <option value='2'>Change Quantity</option>

                        {priceOptions}
    
                        </select>

 </td>
                        
                        <td> 

                        {this.props.price.price && '$'+this.props.price.price}</td>
                        </tr>

                    </tbody>
                    </table>

                        <div style={{float:'right',marginTop:'20%',fontSize:30}}>
                           Total: {this.props.price.price && '$'+this.props.price.price*this.props.price.package_amount}
                        </div>
                    </div>

                    </div>

                    
                    </div>
					</div>
			</div>

            {/*<div className="container">
                    <div className="row button-row">
                        <div className="col-md-4"></div>
                        <div className="col-md-4">
                            <div className="button-group">
                                <Link to="/cheerbox/set-recipient-name" className="button buttonGreen">Go to Dashboard
                                    <div className="ripples buttonRipples"><span className="ripplesCircle"></span></div>
                                </Link>
                            </div>
                        </div>
                        <div className="col-md-4"></div>
                    </div>
                </div>
    */}

			<div className="footer">
				<div className="container">
					<div className="row">
					<div className="col-md-4"></div>
						<div className="col-md-4">

						</div>
						
					</div>
				</div>
			</div>
      	</Wrapper>
    );
  }
}

const mapStatesToProps = state =>{
    return{
        user:state.user.user,
        token:state.user.userToken,
        price:state.pricing.setprice,
        pricing:state.pricing.pricing,

    }
}

const mapDispatchToProps = dispatch =>{
    return{
        getUser: ()=>dispatch(getUser()),
        createUser:(data)=>dispatch(createUser(data)),
        setPricing:(data)=>dispatch(setPricing(data)),
        getPricing: ()=>dispatch(getPricing()),
        
    }
}
export default connect(mapStatesToProps,mapDispatchToProps) (Pricing);
